<template>
    <breakpoint>
        <nav class="navigation" slot-scope="{ smDown }">
            <div
                class="share absolute st-custom-button right-0"
                data-network="sharethis"
                v-if="smDown"
            >
                Share
            </div>
            <ul class="main-nav">
                <router-link
                    v-for="(section, sectionindex) in sections"
                    :key="sectionindex"
                    :to="section.route"
                    v-slot="{ href, route, navigate, isActive, isExactActive }"
                >
                    <li
                        class="parent"
                        :class="[
                            isActive && 'active',
                            isExactActive && 'exact-active',
                            section.name.toLowerCase()
                        ]"
                        v-show="isCurrentPath(href)"
                    >
                        <a :href="href" @click="navigate">{{ section.name }}</a>
                        <nav-tree
                            :items="section.children"
                            :parent="section.route"
                        ></nav-tree>
                    </li>
                </router-link>
            </ul>
        </nav>
    </breakpoint>
</template>

<script>
import NavTree from './nav-tree';
export default {
    props: ['sections'],
    components: { NavTree },
    methods: {
        isCurrentPath(href) {
            const firstRoute = this.$route.matched[0];

            return (
                firstRoute.path === '' ||
                this.$route.matched.length < 2 ||
                firstRoute.path === href.replace('#', '')
            );
        }
    }
};
</script>

<style lang="scss"></style>
